import { useState } from 'react';
import {
  CheckCircle,
  KeyboardArrowDown,
  KeyboardArrowLeft,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Container,
  FormGroup,
  Grid,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { FieldValues, UseFormRegister } from 'react-hook-form';

import Form from 'components/Form';
import SignUpDialog from 'routes/SignUp/SignUpDialog';
import { IFormValues } from 'routes/Main/type';

interface Props extends IFormValues {
  studentGrade: number;
  studentGender: number;
  register: UseFormRegister<FieldValues>;
  isConfirmPassword: boolean;
  onConfirmPassword: () => void;
}

function MyPageForm(props: Props) {
  const [isTerms, setIsTerms] = useState(false);
  const [isPersonal, setIsPersonal] = useState(false);
  const {
    studentGrade,
    studentGender,
    register,
    isConfirmPassword,
    onConfirmPassword,
    getValues,
  } = props;

  const VerificationIcon = () => (
    <CheckCircle
      fontSize="small"
      color="primary"
      sx={{ display: isConfirmPassword ? 'block' : 'none' }}
    />
  );

  const [birth, setBirth] = useState(
    getValues('student_birth').length > 4
      ? getValues('student_birth').slice(0, 4)
      : getValues('student_birth')
  );

  // 이름에 특수문자 넣지못하게 막는
  const [이름, set이름] = useState('');

  const nameRegex = () => {
    let check = /@/;
    return check.test(이름);
  };

  return (
    <Box>
      <Container maxWidth="sm" sx={{ mt: 7.5, mb: 6 }}>
        <Button
          href="/#/"
          size="large"
          color="inherit"
          startIcon={<KeyboardArrowLeft />}
          sx={{ mb: 5, p: 0 }}
        >
          账户设置
        </Button>

        <Stack spacing={2.5}>
          <Form.Item label="Email">
            <Box display="flex" gap={1}>
              <TextField
                fullWidth
                disabled={true}
                {...register('student_id')}
                InputProps={{ readOnly: true }}
              />
            </Box>
          </Form.Item>
          <Form.Item label="密码">
            <Box display="flex" gap={1}>
              <Form.Password
                required
                fullWidth
                helperText="要编辑您的账户信息，请输入当前密码并点击“确认”。"
                placeholder="输入您的当前密码。"
                sx={{ whiteSpace: 'nowrap' }}
                InputProps={{
                  readOnly: isConfirmPassword,
                  endAdornment: <VerificationIcon />,
                }}
                {...register('password')}
              />
              <Button
                variant={'contained'}
                onClick={onConfirmPassword}
                sx={{
                  width: 200,
                  fontSize: 13,
                  maxHeight: 56,
                  whiteSpace: 'nowrap',
                  display: isConfirmPassword ? 'none' : 'block',
                }}
              >
                确认
              </Button>
            </Box>
          </Form.Item>

          <Form.Item label="	新密码">
            <Form.Password
              required={false}
              fullWidth
              helperText="请输入至少包含英文+数字+特殊符号的8位字符。"
              {...register('newPassword')}
            />
          </Form.Item>
          <Form.Item label="再次输入新密码">
            <Form.Password
              required={false}
              fullWidth
              isHideVisibleBtn
              {...register('newPasswordConfirm')}
            />
          </Form.Item>

          <Form.Item label="名字">
            <TextField
              required
              fullWidth
              helperText={nameRegex() ? '請注意不要寫上您的電子郵件地址' : ''}
              color={nameRegex() ? 'warning' : 'success'}
              {...register('student_name', {
                onChange: e => set이름(e.target.value),
              })}
            />
          </Form.Item>
          <Grid container>
            <Grid item xs={6} sx={{ display: 'none' }}>
              <Form.Item label="Gender">
                <Form.MuiRadioGroup
                  i18nKey="GENDER"
                  disabled={true}
                  values={[1, 2]}
                  value={studentGender}
                  defaultValue={studentGender}
                />
              </Form.Item>
            </Grid>
            <Grid item xs={6}>
              <Form.Item label="职位">
                <Form.MuiRadioGroup
                  disabled={true}
                  i18nKey="GRADE"
                  values={[1, 2]}
                  value={studentGrade}
                  defaultValue={studentGrade}
                />
              </Form.Item>
            </Grid>
          </Grid>

          <Form.Item label="学校（大学/学院）">
            <TextField
              disabled={true}
              fullWidth
              {...register('college_name')}
              InputProps={{
                readOnly: true,
                endAdornment: <KeyboardArrowDown />,
              }}
            />
          </Form.Item>
          <Form.Item label="学号">
            <TextField
              disabled={true}
              fullWidth
              InputProps={{ readOnly: true }}
              {...register('student_no')}
            />
          </Form.Item>
          <Form.Item label="出生年份">
            <TextField
              disabled={true}
              fullWidth
              defaultValue={birth}
              InputProps={{ readOnly: true }}
              InputLabelProps={{ shrink: true }}
            />
          </Form.Item>
          <FormGroup sx={{ mt: 2.5 }}>
            <Typography
              gutterBottom
              variant="body2"
              onClick={() => setIsTerms(true)}
              sx={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              Smartnurse条款和条件{' '}
            </Typography>
            <Typography
              variant="body2"
              onClick={() => setIsPersonal(true)}
              sx={{ cursor: 'pointer', textDecoration: 'underline' }}
            >
              收集和使用个人信息的条款和条件{' '}
            </Typography>
          </FormGroup>
          <Form.Item>
            <Button fullWidth size="large" type="submit" variant="contained">
              保存
            </Button>
          </Form.Item>
        </Stack>
      </Container>

      <SignUpDialog.TermsOfService
        isOpen={isTerms}
        onClose={() => setIsTerms(false)}
      />

      <SignUpDialog.PersonalInfo
        isOpen={isPersonal}
        onClose={() => setIsPersonal(false)}
      />
    </Box>
  );
}

export default MyPageForm;
